import {
  DataTable,
  Heading,
  Loader,
} from "@/components";
import { Button, Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import {
  FREQUENCY_ADHOC,
  frequencyTabs,
} from "./consts";
import useDistributionRunTimeDetails from "./useDistributionRunTimeDetails";
import { AddDistributionJob } from "./AddDistributionJob";

const DistributionRunTimeDetails = () => {
  const {
    breadcrumbData,
    title,
    activeFrequencyTab,
    setActiveFrequencyTab,
    onAddJobClick,
    activeStatusTab,
    onStatusTabChange,
    columns,
    isLoadingJobList,
    jobList,
    openAddDialog,
    setOpenAddDialog,
    isEdit,
    selectedJobId,
    statusTabs,
    hasCreatePermission
  } = useDistributionRunTimeDetails();

  return (
    <div className="p-4">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={title} breadcrumbData={breadcrumbData} />
        {activeFrequencyTab === FREQUENCY_ADHOC && hasCreatePermission && (
          <Button type="button" className="h-[40px] px-5" onClick={onAddJobClick}>
            + Add Allocation Job
          </Button>
        )}
      </div>

      <Tabs value={activeFrequencyTab} onValueChange={setActiveFrequencyTab}>
        <TabsList className="gap-x-6 bg-transparent p-0">
          {frequencyTabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="hover:cursor-pointer text-gray-400 hover:text-primary px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary data-[state=active]:shadow-none"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={activeFrequencyTab}>
          {isLoadingJobList ? <Loader /> :
            <Tabs value={activeStatusTab} onValueChange={onStatusTabChange} className="pt-4">
              <TabsList className="gap-x-4 bg-transparent p-0">
                {statusTabs.map((tab) => (
                  <TabsTrigger
                    key={tab.value}
                    value={tab.value}
                    className="hover:cursor-pointer border-black hover:text-primary border-1 shadow-none data-[state=active]:bg-primary data-[state=active]:border-b-none data-[state=active]:border-primary data-[state=active]:text-white data-[state=active]:shadow-none"
                  >
                    {tab.label}
                  </TabsTrigger>
                ))}
              </TabsList>
  
              {statusTabs.map((tab) => (
                <TabsContent key={tab.value} value={tab.value} className="w-full pt-4">
                  <div className="overflow-x-auto w-full">
                    <div className="min-w-[1180px]">
                      <DataTable
                        columns={columns}
                        data={jobList || []}
                      />
                    </div>
                  </div>
                </TabsContent>
              ))}
            </Tabs>
          }
        </TabsContent>
      </Tabs>
      {openAddDialog && 
        <AddDistributionJob
          open={openAddDialog}
          setOpen={setOpenAddDialog} 
          isEdit={isEdit}
          jobId={selectedJobId}
          frequency={activeFrequencyTab}
          type={activeStatusTab}
        />
      }
    </div>
  );
};

export default DistributionRunTimeDetails;
